import {Logger} from '@gravity-ui/i18n';

export enum Langs {
    Ru = 'ru',
    En = 'en',
}

export enum RegionLangs {
    Ru = 'ru',
    Il = 'il',
    AI = 'ai',
}

type ContactDialogSettings = {
    /* Иллюстрация в диалоге изменения телефона на шаге ввода номера телефона. */
    inputPhoneImageUrl?: string;
    /* Иллюстрация в диалоге изменения телефона на шаге ввода кода подтверждения. */
    phoneVerifyCodeImageUrl?: string;
    /* Иллюстрация в диалоге изменения почты на шаге ввода почты. */
    inputEmailImageUrl?: string;
    /* Иллюстрация в диалоге изменения почты на шаге ввода кода подтверждения. */
    emailVerifyCodeImageUrl?: string;
    /* Иллюстрация в диалоге подключения Telegram. */
    telegramCodeImageUrl?: string;
};

export interface ComponentsConfig {
    regionLang?: 'ru' | 'il' | 'ai';
    lang?: 'ru' | 'en';
    definitionListValueMaxWidth?: number;
    logger?: Logger;
    /**
     * Fixes a layout bug in the case of a multiline title
     * But a breaking change
     * It will be default behavior in future
     */
    formLayoutRowTitleDisplayInline?: boolean;
    dateFormat?: string;
    timeFormat?: string;
    /* Кастомные иллюстрации для диалогов редактирования номера телефона, email и telegram. */
    contactDialogSettings?: ContactDialogSettings;
}

type ConfigSubscriber = (config: ComponentsConfig) => void;

let configure: ComponentsConfig = {};
let subscribers: ConfigSubscriber[] = [];

export const setConfig = (config: ComponentsConfig) => {
    if (config) {
        configure = {...configure, ...config};
        subscribers.forEach((sub) => {
            sub(configure);
        });
    }
};

export const subscribeConfigure = (sub: ConfigSubscriber): (() => void) => {
    subscribers.push(sub);

    return () => {
        subscribers = subscribers.filter((el) => el === sub);
    };
};

export const getConfig = () => configure;
